import { proxy, useSnapshot } from "valtio";

interface IPreviewBoxStore {
	readonly previewBox: Readonly<eXpress.math.IRect>;
	updatePreviewBox(newPreviewBox: eXpress.math.IRect): void;
}

const previewBoxStore = proxy<IPreviewBoxStore>({
	previewBox: eXpress.math.Rect.zero,

	updatePreviewBox(newRect: eXpress.math.IRect) {
		// Don't trigger a rerender for the same rect
		if (!eXpress.math.Rect.isSimilar(previewBoxStore.previewBox, newRect)) {
			(previewBoxStore as any).previewBox = newRect; // Only allow to change the readonly property with this function
		}
	},
});

/** Use PreviewBox information */
export const usePreviewBox = () => useSnapshot(previewBoxStore);

/**
 * Return the previewBox, but don't trigger a rerender
 * This is usefull when only needed in a callback
 */
export const useGetPreviewBoxStore = () => previewBoxStore;
